import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../common/config.service';
export interface Notification {
  id: number;
  type: string;
  title: string;
  subtitle: string;
  created_at: string;
  is_read: boolean;
  rating: number | null;
  order_id: number | null;
  amount: number | null;
  transaction_id: number | null;
}

export interface NotificationResponse {
  success: number;
  statusCode: number;
  msg: string;
  result: Notification[];
  filters: string[];
  unreadCount: number;
  pagination: {
    total: number;
    current_page: number;
    per_page: number;
    total_pages: number;
  };
}

interface MarkNotificationReadPayload {
  app_notification_ids?: number[];
  mark_all?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private configServ: ConfigService, private http: HttpClient) {}

  getNotifications(page: number = 1, limit: number = 10, type: string = 'all'): Observable<NotificationResponse> {
    const payload = {
      page: page,
      limit: limit,
      type: type
    };
    return this.http.post<NotificationResponse>(
      this.configServ.apiRoutes.NOTIFICATION_LISTING,
      payload
    );
  }

  markAsRead(notificationId: number[]): Observable<any> {
    return this.http.post(this.configServ.apiRoutes.READ_NOTIFICATION, {
      app_notification_ids: notificationId
    });
  }

  markAllAsRead(): Observable<any> {
    return this.http.post(
      this.configServ.apiRoutes.READ_NOTIFICATION,
      {
        mark_all: true
      }
    );
  }

}